import styled from "styled-components";

export const GamePlayPcHeaderBarGameModeToggleButtonDefaultBox = styled.div`
    border-radius: 50%;
    width: 50%;
    margin: 1px;
    background-color: ${props => props.theme.colors.textLight};
`